import FileUploadButton from '@components/common/FileUploadButton';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FeedData, FeedDataItem } from '@models/feed';
import { cdnImageUrl } from '@utils/image';
import { Button, Input } from 'antd';
import React from 'react';

interface ProductCategoryItemProps {
  onDeleteItem?: (event: any) => void;
  onChange?: (item: FeedData<FeedDataItem>) => void;
  onChangeImage?: (file: File) => void;
  id: any;
  item: FeedData<FeedDataItem>;
}

export const ProductCategoryItem: React.FC<ProductCategoryItemProps> = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: props.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const { onDeleteItem, onChange, item } = props;

  return (
    <div ref={setNodeRef} style={{ ...style, ...itemStyle }} {...attributes} {...listeners}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
          }}>
          {item.imageUrl && (
            <img src={cdnImageUrl(item.imageUrlTemp || item.imageUrl)} style={{ width: '64px', height: '64px' }} />
          )}
          <FileUploadButton
            accept={['.jpg', '.jpeg', '.png', '.webp', '.svg'].join(',')}
            className="ant-btn"
            onChange={(e) => {
              if (e.target.files && e.target.files.length > 0) {
                const file = e.target.files[0];
                props.onChangeImage && props.onChangeImage(file);
              }
            }}>
            아이콘 변경
          </FileUploadButton>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <label style={{ fontSize: '12px', fontWeight: 500 }}>Key:</label>
            <Input
              value={item.type}
              onChange={(e) => {
                onChange && onChange({ ...item, type: e.target.value });
              }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <label style={{ fontSize: '12px', fontWeight: 500 }}>라벨 (한국어):</label>
            <Input
              value={item.label?.ko}
              onChange={(e) => {
                onChange && onChange({ ...item, label: { ...item.label, ko: e.target.value } });
              }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <label style={{ fontSize: '12px', fontWeight: 500 }}>라벨 (영어):</label>
            <Input
              value={item.label?.en}
              onChange={(e) => {
                onChange && onChange({ ...item, label: { ...item.label!, en: e.target.value } });
              }}
            />
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            danger
            onClick={(e) => {
              onDeleteItem && onDeleteItem(e);
            }}>
            삭제
          </Button>
        </div>
      </div>
    </div>
  );
};

const itemStyle: React.CSSProperties = {
  padding: '16px',
  backgroundColor: 'white',
  border: '1px solid #d9d9d9',
  borderRadius: '8px',
  cursor: 'grab',
  minWidth: '200px',
  width: '200px',
};
